import React, { useState, useRef, useCallback, useEffect } from 'react';
import axios from 'axios';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext.js';
import DragDrop2 from "./DragDrop2.js";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MessageSnackBar from './MessageSnackBar.js';
import CircularProgress from '@mui/material/CircularProgress';

import { 
    Button, 
    Grid,
    Paper ,
    Typography } from '@mui/material';

const ASNManagement = (props) => {
    //SECTION USER CONTEXT and HEADERS
    const userData = useContext(UserContext);
    const storedHeaders = sessionStorage.getItem('headers');
    const headers = storedHeaders ? JSON.parse(storedHeaders) : {};
    // !SECTION

    //SECTION Message Bar Controls
      const [ messageBarMessage, setMessageBarMessage ] = React.useState('');
      const [ messageBarOpen, setMessageBarOpen ] = React.useState(false);
      const [ messageSeverity, setMessageSeverity ] = React.useState('success');
      const handleMessageBarClosing = () => {
        setMessageBarOpen(false);
      };
      //!SECTION

    //SECTION Component Controls
    const itemMessage = 'ASN Management';

    const toggleItems = () => {
      if (viewItems){
          setViewItems(false);
          setViewItemsMessage(`${itemMessage}`);
          // console.log("user data", userData.name)
      }else{
          // getWarehouseList(userData.email)
          setViewItems(true);
          setViewItemsMessage(`Hide ${itemMessage}`);
      };
  } ;

    const [ viewItems, setViewItems ] = React.useState(false);
    const [ viewItemsMessage, setViewItemsMessage ] = React.useState(`View ${itemMessage}`);

    //!SECTION
  
  //SECTION - Spinner Controls
  const [ viewUpdateSpinner, setViewUpdateSpinner ] = React.useState(false);
  const [ viewShippedReceivedSpinner, setViewShippedReceivedSpinner ] = React.useState(false);
  const [ viewOrderInStockDiscrepanciesSpinner, setViewOrderInStockDiscrepanciesSpinner ] = React.useState(false);
  const [ viewMobileMessageUpdateSpinner, setViewMobileMessageUpdateSpinner ] = React.useState(false);
  const [ viewShippedReceivedAllPOsSpinner, setViewShippedReceivedAllPOsSpinner ] = React.useState(false);
  const toggleUpdateSpinner = (url) => {
    if (url === shipmentStatusUrl){
      setViewUpdateSpinner(prevState => !prevState); 
     }
    if (url === shippedReceivedUrl){
      setViewShippedReceivedSpinner(prevState => !prevState); 
      }
    if (url === orderInStockDiscrepanciesUrl){
      setViewOrderInStockDiscrepanciesSpinner(prevState => !prevState); 
      }
      if (url === mobileMessageUpdateURL){
        setViewMobileMessageUpdateSpinner(prevState => !prevState);
      }
      if (url === shippedReceivedAllPOsUrl){
        setViewShippedReceivedAllPOsSpinner(prevState => !prevState);
      }
    };
  //!SECTION

  //SECTION - URLS
    const shipmentStatusUrl = `/Shipments/updateShipmentStatus` // updates the shipment status from carrier
    const shippedReceivedUrl = `/Shipments/shippedReceivedItemsProcessing` //updates the shipment to inbound
    const orderInStockDiscrepanciesUrl = `/Shipments/orderinstockdiscrepancy` //reviews if the item was in stock when ordered
    const mobileMessageUpdateURL = '/Messages/poreviewmobilemessages' // updates the mobile messages to match the DNIs
    const shippedReceivedAllPOsUrl = `/Shipments/shippedReceivedItemsProcessingAllPOs` //updates the shipment all POs to inbound 

    //SECTION - Put data processing

    //This takes a URL and parameters and sends a put request to the backend
    const handlePutDataProcessing = (url, parameters) => {
      toggleUpdateSpinner(url);
      axios
        .put(
          url,
          parameters,
          { headers: headers }
        )
        .then(function async(response) {
          toggleUpdateSpinner(url);
          setMessageBarMessage(response.data.message);
          setMessageBarOpen(true);
          setMessageSeverity("success") // error: red, warning: orange, information: blue, success: green
        })
        .catch(function (error) {
          toggleUpdateSpinner(url);
          if (error.response.status === 401) {
            alert ("Your session has expired. Please login again.");
          }
          if (error.response.status !== 401) {
            setMessageBarMessage(`Oh no! Something went wrong. Please try again or email info@edonconnect.tech for help. ${error.message}`);
            setMessageBarOpen(true);
            setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
          }
        })
        .then(function () {
          // always executed
        });
      };
    //!SECTION

    //SECTION - Put data processing

    //This takes a URL and parameters and sends a put request to the backend
    const handlePatchUpdate = (url, parameters) => {
      toggleUpdateSpinner(url);
      axios
        .patch(
          url,
          parameters,
          { headers: headers }
        )
        .then(function async(response) {
          toggleUpdateSpinner(url);
          setMessageBarMessage(response.data.message);
          setMessageBarOpen(true);
          setMessageSeverity("success") // error: red, warning: orange, information: blue, success: green
        })
        .catch(function (error) {
          toggleUpdateSpinner(url);
          if (error.response.status === 401) {
            alert ("Your session has expired. Please login again.");
          }
          if (error.response.status !== 401) {
            setMessageBarMessage(`Oh no! Something went wrong. Please try again or email info@edonconnect.tech for help. ${error.message}`);
            setMessageBarOpen(true);
            setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
          }
        })
        .then(function () {
          // always executed
        });
      };
    //!SECTION


  return (  

      <>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ alignContent: "center", border: 0 }}
      >
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
        >
          <Button 
          onClick={toggleItems}
          startIcon={<ManageAccountsIcon size="large" />}
          >
            {" "}
            {viewItemsMessage}
          </Button>

          {/* Component Items */}
          {viewItems &&
          <>
          <MessageSnackBar messageBarMessage={messageBarMessage} messageBarOpen={messageBarOpen} handleMessageBarClosing={handleMessageBarClosing} messageSeverity={messageSeverity} />
            
          {/* Drag and Drop 2 */}
          <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{ alignContent: "center", border: 0 }}
          >
          <DragDrop2
           />
          </Grid>
          
          <Grid container marginTop={5} marginBottom={5} sx={{justifyContent:'center', alignItems:'center', alignContent:'center', pb:10, pt:5,  border:1, borderStyle: 'dotted', borderRadius: '5px'  }}>
          <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{ justifyContent: "center", alignItems:'center', alignContent:'center', border: 0, marginTop: 0, marginBottom: 10 }}
          >
            <Typography variant="h4" align="center" >
              Shipment and Replenishment Processing
            </Typography>
          </Grid>

          {/* UpDate shipment Status */}
          <Grid
          item
          xs={4}
          md={4}
          lg={4}
          sx={{  border: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
          <Button onClick={() => handlePutDataProcessing(shipmentStatusUrl, {})} variant='contained' align="center" component="label">
            Update Shipment Status
          {viewUpdateSpinner &&
            <CircularProgress sx={{margin:1}} color="inherit" size ={20}/>
            }
          

          </Button>
          </Grid>
          
          {/* Received shipped item Inbounded */}

          <Grid
          item
          xs={4}
          md={4}
          lg={4}
          sx={{ border: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
          <Button onClick={() => handlePutDataProcessing(shippedReceivedUrl, {})} variant='contained' component="label">
            Received Item Processing

          {viewShippedReceivedSpinner &&
          <CircularProgress sx={{margin:1}} color="inherit" size ={20}/>
          }
          
          </Button>
          </Grid>


          {/* Received shipped item Inbounded */}

          <Grid
          item
          xs={4}
          md={4}
          lg={4}
          sx={{ border: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
          <Button onClick={() => handlePutDataProcessing(orderInStockDiscrepanciesUrl, {})} variant='contained' component="label">
            Order Stock Discrepancies

          {viewOrderInStockDiscrepanciesSpinner &&
          <CircularProgress sx={{margin:1}} color="inherit" size ={20}/>
          }
          
          </Button>
          </Grid>

          {/* Container for bottom row buttons */}
          <Grid 
            container 
            item 
            xs={12} 
            spacing={3}
            sx={{ 
              justifyContent: 'space-around', 
              alignItems: 'center', 
              mt: 5,
              border: 0,
              borderStyle: 'dotted',
              borderRadius: '5px'
            }}
          >

          {/* Received shipped item Inbounded */}

          <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{ border: 0, 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            mt: 1 }}
          >
          <Button onClick={() => handlePatchUpdate(mobileMessageUpdateURL, {})} variant='contained' component="label">
            Update Old Mobile Messages

          {viewMobileMessageUpdateSpinner &&
          <CircularProgress sx={{margin:1}} color="inherit" size ={20}/>
          }
          
          </Button>
          </Grid>

          {/* Received shipped item Inbounded */}

          <Grid
          item
          xs={3}
          md={3}
          lg={3}
          sx={{ border: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1 }}
          >
          <Button onClick={() => handlePutDataProcessing(shippedReceivedAllPOsUrl, {})} variant='contained' component="label">
            Received Items All POs Processing

          {viewShippedReceivedAllPOsSpinner &&
          <CircularProgress sx={{margin:1}} color="inherit" size ={20}/>
          }
          
          </Button>
          </Grid>
          </Grid>


          </Grid>

        </>
    }
        </Paper>
      </Grid>
  </>


  );
};
export default ASNManagement;